export default "__VITE_ASSET__kFqcLXDm__"